import React from 'react';
import { Grid } from 'semantic-ui-react';
import MetricCard from '../Dashboard/MetricCard';
import { TrainingMetricsDto } from '../../services/learning/QuizReportService';

interface TrainingMetricsOverviewProps {
  metrics: TrainingMetricsDto | null;
}

const TrainingMetricsOverview: React.FC<TrainingMetricsOverviewProps> = ({ metrics }) => {
  if (!metrics) {
    return null;
  }

  return (
    <Grid columns={4} stackable>
      <Grid.Column>
        <MetricCard
          title="Total de Turmas"
          value={metrics.totalTrainingTeams}
          icon="users"
          color="#3498db"
          tooltip="Número total de turmas de treinamento cadastradas no sistema"
        />
      </Grid.Column>
      <Grid.Column>
        <MetricCard
          title="Turmas Ativas"
          value={metrics.activeTrainingTeams}
          icon="check circle"
          color="#2ecc71"
          tooltip="Número de turmas de treinamento atualmente ativas"
        />
      </Grid.Column>
      <Grid.Column>
        <MetricCard
          title="Total de Trainees"
          value={metrics.totalTrainees}
          icon="user"
          color="#9b59b6"
          tooltip="Número total de trainees em todas as turmas"
        />
      </Grid.Column>
      <Grid.Column>
        <MetricCard
          title="Trainees Ativos"
          value={metrics.activeTrainees}
          icon="user circle"
          color="#16a085"
          tooltip="Número de trainees atualmente ativos"
        />
      </Grid.Column>
      <Grid.Column>
        <MetricCard
          title="Taxa de Aprovação"
          value={`${metrics.overallApprovalRate.toFixed(1)}%`}
          icon="checkmark"
          color="#27ae60"
          tooltip="Percentual geral de aprovação em todos os questionários"
        />
      </Grid.Column>
      <Grid.Column>
        <MetricCard
          title="Média Geral"
          value={`${metrics.overallAverageScore.toFixed(1)}%`}
          icon="chart line"
          color="#f39c12"
          tooltip="Média geral de notas de todos os trainees"
        />
      </Grid.Column>
      <Grid.Column>
        <MetricCard
          title="Total de Questionários"
          value={metrics.totalQuizzes}
          icon="file text"
          color="#e67e22"
          tooltip="Número total de questionários disponíveis"
        />
      </Grid.Column>
      <Grid.Column>
        <MetricCard
          title="Tentativas Completas"
          value={metrics.completedAttempts}
          icon="check square"
          color="#3498db"
          subtitle={`${metrics.inProgressAttempts} em progresso`}
          tooltip="Número de tentativas de questionários completadas"
        />
      </Grid.Column>
    </Grid>
  );
};

export default TrainingMetricsOverview;

